import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=91c8b99a&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=91c8b99a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c8b99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91c8b99a')) {
      api.createRecord('91c8b99a', component.options)
    } else {
      api.reload('91c8b99a', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=91c8b99a&scoped=true", function () {
      api.rerender('91c8b99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profiles/UserProfile.vue"
export default component.exports